export const CDN_ASSET_BASE_URL =
  "https://cdn.catexpert.ab-inbev.com/assets/";
export const LOCAL_ASSET_BASE_URL = "/assets/";

const LOCAL_HOSTNAMES = new Set(["localhost", "127.0.0.1", "0.0.0.0", "::1"]);

const LOCAL_ASSET_PATH = /^(?:(?:\.\.?\/)*\/?)assets\/(.+)$/;

/** Returns the path below the assets root for local and CatExpert CDN URLs. */
export function getAssetPath(url: string): string | null {
  const value = url.trim();

  if (value.startsWith(CDN_ASSET_BASE_URL)) {
    return value.slice(CDN_ASSET_BASE_URL.length);
  }

  return LOCAL_ASSET_PATH.exec(value)?.[1] ?? null;
}

/** Converts a repository asset URL to its CDN equivalent. */
export function toCdnAssetUrl(url: string): string {
  const assetPath = getAssetPath(url);
  return assetPath === null ? url : `${CDN_ASSET_BASE_URL}${assetPath}`;
}

/** Converts a CDN asset URL to the root-relative repository fallback URL. */
export function toLocalAssetUrl(url: string): string {
  const assetPath = getAssetPath(url);
  return assetPath === null ? url : `${LOCAL_ASSET_BASE_URL}${assetPath}`;
}

export function isCdnAssetUrl(url: string): boolean {
  return url.trim().startsWith(CDN_ASSET_BASE_URL);
}

export function isLocalAssetFallbackEnabled(
  hostname = typeof location === "undefined" ? "" : location.hostname,
): boolean {
  return LOCAL_HOSTNAMES.has(hostname.toLowerCase());
}

/** Sets an image to CDN-first loading with a one-time local fallback. */
export function setImageAssetSource(
  image: HTMLImageElement,
  assetUrl: string,
): void {
  const cdnUrl = toCdnAssetUrl(assetUrl);
  if (isLocalAssetFallbackEnabled()) {
    image.addEventListener(
      "error",
      () => {
        image.src = toLocalAssetUrl(cdnUrl);
      },
      { once: true },
    );
  }
  image.src = cdnUrl;
}
